'use client'
import { useTranslations } from 'next-intl'
import React from 'react'
import styles from './styles.module.scss'
import { usePremiumSupport } from '@l2p/common-hooks'
import { useConfig } from '@l2p/swr-hooks'

const SupportButton: React.FC<{ text?: string }> = ({ text }) => {
  const { openManager } = usePremiumSupport()
  const config = useConfig()
  const t = useTranslations('translation')

  if (config?.liveChatShouldDisabled) return null

  return (
    <div className={styles.container} onClick={openManager}>
      <img src="/img/icons/support.svg" alt="support" />
      <span>{text ? text : t('support')}</span>
    </div>
  )
}

export default SupportButton
